import { useEffectOnce } from "react-use";

import { APIResponseSubscriber, useAPIContext } from "./apiContext.ts";

export function useResponseSubscriber(cb: APIResponseSubscriber) {
  if (typeof cb !== "function") {
    throw new TypeError("Argument 'cb' must be a function");
  }

  const { subscribe } = useAPIContext();

  useEffectOnce(() => {
    const unsubscribe = subscribe(cb);
    return () => unsubscribe();
  });
}
